<p-toolbar class="app-header">
  <ng-template pTemplate="start">
    <img src="./assets/images/markant-logo-1024x231.png" alt="Logo" class="app-header__logo" />
  </ng-template>

  <ng-template pTemplate="end">
    <button
      type="button"
      class="app-header__user"
      [attr.aria-label]="displayName()"
      (click)="userMenu.toggle($event)"
    >
      <p-avatar icon="pi pi-user" shape="circle" />
    </button>

    <p-tieredMenu #userMenu [model]="menuModel()" [popup]="true" />
  </ng-template>
</p-toolbar>
